import './Contributors.css';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import sanityClient from '../../sanityClient';
import { postContributorQuery } from '../../queries/postQuery';
import { contributorQuery } from '../../queries/contributorQuery';
import PortableTextComponent from '../../components/PortableText/PortableText';
import { StandardLayout } from '../../layouts/StandardLayout';
import { PostGrid } from '../../components/PostGrid/PostGrid';

export default function SingleContributor(){
    const [contributorData, setContributorData] = useState(null);
    const [postData, setPostData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const { slug } = useParams();

    useEffect(() => {
        if (!slug) return;

        setIsLoading(true);
        sanityClient
        .fetch(contributorQuery, {slug})
        .then((data) => {
            if (data) {
                setContributorData(data);
                return data;
            } else {
                setError('Contributor not found.');
                throw new Error('Contributor not found.');
            }
        })
        .then((contributor) => {
            const contributorId = contributor._id;
            return sanityClient.fetch(postContributorQuery, {contributorId: contributorId})
        }).then((data) => {
            if(data){
                setPostData(data);
            } else{
                setError('Post not found.');
            }
            setIsLoading(false);
        })
        .catch((err) => {
            console.error(err);
            setError('Failed to fetch post.');
            setIsLoading(false);
        });
    }, [slug]);

    if (isLoading) {
      return <StandardLayout title="Loading..." content="Loading..." />;
    }

    if (error) {
      return <StandardLayout title="Error" content={error} />;
    }
    
    if (!contributorData) {
      return <StandardLayout title="Not Found" content="This contributor could not be found." />;
    }

    let content = null;
    if(postData.length === 0){
        content = 'No posts yet for this category.'
    } else{
        content = 
        <>
            <div className='contributorTile'>
                <h4 className='contributorName'>{contributorData.name}</h4>
                <div className='contributorBio'>
                    <PortableTextComponent content={contributorData.bio} />
                </div>
            </div>
            <PostGrid posts={postData} />
        </>
    }
    return(
        <StandardLayout title={`all posts by ${contributorData.name}`} content={content} />
    )
}